import { render, staticRenderFns } from "./stopEvent.vue?vue&type=template&id=fb1512f0&scoped=true"
import script from "./stopEvent.vue?vue&type=script&lang=js"
export * from "./stopEvent.vue?vue&type=script&lang=js"
import style0 from "./stopEvent.vue?vue&type=style&index=0&id=fb1512f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1512f0",
  null
  
)

export default component.exports